import { useUpdateUserSettings } from 'features/user';
import React from 'react';
import { SelectTagsContextMenu } from 'shared/components/connected/select-tags-context-menu';
import { ID } from 'shared/types/id';

import { useExistingFilterTags } from '../../hooks/use-existing-filter-tags';

export type FilterContextMenuProps = Omit<
  React.ComponentProps<typeof SelectTagsContextMenu>,
  'activeTags' | 'onTag'
>;

export const FilterContextMenu: React.FC<FilterContextMenuProps> = ({
  ...selectTagsContextMenuProps
}) => {
  const updateUserSettings = useUpdateUserSettings();
  const activeFilterTags = useExistingFilterTags();
  const toggleFilter = (id: ID) => {
    const newTags = activeFilterTags.filter((tagId) => tagId !== id);
    if (newTags.length === activeFilterTags.length) {
      newTags.push(id);
    }
    updateUserSettings({
      allTasks: {
        filterByTags: newTags,
      },
    });
  };

  return (
    <SelectTagsContextMenu
      {...selectTagsContextMenuProps}
      onTag={toggleFilter}
      activeTags={activeFilterTags}
    />
  );
};
